import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const PrivacyAndDataHandling_MultiListCard = () => {

    return (
        <>
            <Row>
                <Col className='card_margin' lg="12">
                    <Card className='multi_list_card'>
                        <Card.Title className='multi_list_card_content_title'>Data Use Policy</Card.Title>
                        <div className='multi_list_card_content'>
                            <p>
                                We collect only what's required for the stated purpose. By default, we do not train on your data. 
                                Access is gated by SSO/MFA with RBAC/least-privilege, and every access is logged. You can export 
                                your data anytime and request verified deletion, including purge of backups on schedule. Model 
                                selection is configurable (hosted or private endpoints) to align with your policies.
                            </p>
                        </div>
                    </Card>
                </Col>
            </Row>
            
            <Row>
                <Col className='card_margin' lg="6">
                    <Card className='multi_list_card'>
                        <Card.Title className='multi_list_card_content_title'>Retention & Deletion</Card.Title>
                        <div className='multi_list_card_content'>
                            <ul>
                                <li>Configurable retention windows for logs & artifacts (e.g., 30–90 days)</li>
                                <li>Verified deletion on request; purge reports available</li>
                                <li>Backups aged out per schedule; restore testing documented</li>
                            </ul>
                        </div>
                    </Card>
                </Col>
                
                <Col className='card_margin' lg="6">
                    <Card className='multi_list_card'>
                        <Card.Title className='multi_list_card_content_title'>Residency & Rights</Card.Title>
                        <div className='multi_list_card_content'>
                            <ul>
                                <li>Region selection for GDPR/DPDP and internal policy needs</li>
                                <li>Data subject rights: access, rectification, portability, erasure</li>
                                <li>Sensitive data options: PII redaction, tokenization, customer-managed keys</li>
                            </ul>
                        </div>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default PrivacyAndDataHandling_MultiListCard